// src/recoil/signupFormState.ts
import { atom } from 'recoil';

export interface SignupFormData {
  identifier: string;
  password: string;
  confirmPassword: string;
  email: string;
  emailCode: string;
  phoneNumber: string;
  name: string;
  zipCode: string;
  defaultAddress: string;
  detailAddress: string;
  businessNumber: string;
  businessRepresentativeName: string;
  businessOpenDate: string;
  businessName: string;
  businessZipCode: string;
  businessDefaultAddress: string;
  businessDetailAddress: string;
  businessAccountBank: string;
  businessAccountNumber: string;
}

export const signupFormState = atom<SignupFormData>({
  key: 'signupFormState',
  default: {
    identifier: '',
    password: '',
    confirmPassword: '',
    email: '',
    emailCode: '',
    phoneNumber: '',
    name: '',
    zipCode: '',
    defaultAddress: '',
    detailAddress: '',
    businessNumber: '',
    businessRepresentativeName: '',
    businessOpenDate: '',
    businessName: '',
    businessZipCode: '',
    businessDefaultAddress: '',
    businessDetailAddress: '',
    businessAccountBank: '',
    businessAccountNumber: '',
  },
});
